import { CAMPAIGN_TYPE } from '../../../../config/constants';

export const CAMPAIGN_LAUNCHER_SET_ACTIVE_STEP = 'CAMPAIGN_LAUNCHER_SET_ACTIVE_STEP';
export const CAMPAIGN_LAUNCHER_SELECT_ASIN = 'CAMPAIGN_LAUNCHER_SELECT_ASIN';
export const CAMPAIGN_LAUNCHER_UNSELECT_ASIN = 'CAMPAIGN_LAUNCHER_UNSELECT_ASIN';
export const CAMPAIGN_LAUNCHER_GOTO_NEXT_STEP = 'CAMPAIGN_LAUNCHER_GOTO_NEXT_STEP';
export const CAMPAIGN_LAUNCHER_GOTO_PREVIOUS_STEP = 'CAMPAIGN_LAUNCHER_GOTO_PREVIOUS_STEP';

export const setActiveSetAction = (activeStep) => ({
  type: CAMPAIGN_LAUNCHER_SET_ACTIVE_STEP,
  payload: activeStep,
});

export const selectAsinAction = (asin) => ({
  type: CAMPAIGN_LAUNCHER_SELECT_ASIN,
  payload: asin,
});

export const unselectAsinAction = (asin) => ({
  type: CAMPAIGN_LAUNCHER_UNSELECT_ASIN,
  payload: asin,
});

export const continueToNextStepAction = () => ({
  type: CAMPAIGN_LAUNCHER_GOTO_NEXT_STEP,
});

export const goToPreviousStepAction = () => ({
  type: CAMPAIGN_LAUNCHER_GOTO_PREVIOUS_STEP,
});

const init = {
  activeStep: 0,
  canContinue: false,
  selectedInput: null,
  selectedProducts: [],
  selectedCreative: null,
  config: [
    {
      name: 'Campaign 1',
      type: CAMPAIGN_TYPE.SP,
      targeting: 'auto',
      budget: 100,

      adGroups: [{ name: 'test', defaultBid: 1, adGroupTargeting: 'targets' }],
    },
    {
      name: 'Campaign 2',
      type: CAMPAIGN_TYPE.SP,
      targeting: 'manual',
      budget: 100,
      adGroups: [{ name: 'test', defaultBid: 1.3, adGroupTargeting: 'targets' }],
    },
  ],
};

export default (state = init, action) => {
  let newState = { ...state };

  switch (action.type) {
    case CAMPAIGN_LAUNCHER_SET_ACTIVE_STEP:
      newState.activeStep = action.payload;
      break;
    case CAMPAIGN_LAUNCHER_SELECT_ASIN:
      newState.selectedProducts = [...newState.selectedProducts, action.payload];
      newState.canContinue = newState.selectedProducts.length > 0;
      newState.selectedCreative = null;
      newState.selectedInput = 'productAds';
      break;
    case CAMPAIGN_LAUNCHER_UNSELECT_ASIN:
      newState.selectedProducts = newState.selectedProducts.filter((i) => i !== action.payload);
      newState.canContinue = newState.selectedProducts.length > 0;
      break;
    case CAMPAIGN_LAUNCHER_GOTO_PREVIOUS_STEP:
      newState.activeStep -= 1;
      newState.canContinue = false;
      break;
    case CAMPAIGN_LAUNCHER_GOTO_NEXT_STEP:
      newState.activeStep += 1;
      newState.canContinue = false;
      break;
    default:
  }
  return newState;
};
